import { isMobileOnly, isTablet } from 'mobile-device-detect'

export function getCookieValue(name) {
  return (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  )
}
export function checkIsMobileDevice() {
  if (
    window.forceMobileView != null &&
    (window.forceMobileView === true || window.forceMobileView === 'true')
  ) {
    return true
  }

  if (getCookieValue('requestedSession') === 'desktop') {
    // if(true){
    return false
  } else {
    return isMobileOnly
  }
}
export function checkIsTabletDevice() {
  if (
    window.forceMobileView != null &&
    (window.forceMobileView === true || window.forceMobileView === 'true')
  ) {
    return true
  }

  if (getCookieValue('requestedSession') === 'desktop') {
    // if(true){
    return false
  } else {
    return isTablet
  }
}
